module.exports = __webpack_public_path__ + "img/table-arrow.a16bb2de.svg";